// // src/pages/Settings.jsx (or src/components/SettingsPage.jsx)
// import { useState } from "react";
// import { useTheme } from "../context/ThemeContext";
// import {
//   User,
//   Mail,
//   ShieldCheck,
//   Bell,
//   Globe,
//   Moon,
//   Sun,
//   Lock,
//   Save,
// } from "lucide-react";

// export default function Settings() {
//   const { theme, toggleTheme } = useTheme();
//   const [notifications, setNotifications] = useState({
//     email: true,
//     push: true,
//     transactionAlerts: true,
//   });

//   const [profile, setProfile] = useState({
//     name: "Admin User",
//     email: "admin@onedesk.com",
//     phone: "+91 98765 43210",
//   });

//   const handleNotificationChange = (key) => {
//     setNotifications((prev) => ({
//       ...prev,
//       [key]: !prev[key],
//     }));
//   };

//   const handleProfileChange = (e) => {
//     const { name, value } = e.target;
//     setProfile((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleSaveProfile = () => {
//     // TODO: API call to save profile
//     alert("Profile updated successfully!");
//   };

//   return (
//     <div className="p-6 lg:p-8 space-y-8">
//       {/* Header */}
//       <div>
//         <h1 className="text-3xl font-bold text-primary-text">Settings</h1>
//         <p className="text-secondary-text mt-2">Manage your account preferences and security</p>
//       </div>

//       <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
//         {/* Main Content */}
//         <div className="lg:col-span-2 space-y-6">
//           {/* Profile Section */}
//           <div className="bg-card-bg rounded-2xl border border-card-border shadow-2xl overflow-hidden">
//             <div className="px-8 py-6 border-b border-card-border bg-secondary-bg">
//               <h2 className="text-xl font-semibold flex items-center gap-3">
//                 <User className="w-5 h-5 text-accent-orange-400" />
//                 Profile Information
//               </h2>
//             </div>
//             <div className="p-8 space-y-6">
//               <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                 <div>
//                   <label className="block text-sm font-medium text-secondary-text mb-2">
//                     Full Name
//                   </label>
//                   <input
//                     type="text"
//                     name="name"
//                     value={profile.name}
//                     onChange={handleProfileChange}
//                     className="
//                       w-full px-5 py-3 rounded-xl border border-card-border
//                       bg-secondary-bg text-primary-text
//                       focus:border-accent-orange-500 focus:ring-2 focus:ring-accent-orange-500/20
//                     "
//                   />
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-secondary-text mb-2">
//                     Email Address
//                   </label>
//                   <input
//                     type="email"
//                     name="email"
//                     value={profile.email}
//                     onChange={handleProfileChange}
//                     className="
//                       w-full px-5 py-3 rounded-xl border border-card-border
//                       bg-secondary-bg text-primary-text
//                       focus:border-accent-orange-500 focus:ring-2 focus:ring-accent-orange-500/20
//                     "
//                   />
//                 </div>

//                 <div>
//                   <label className="block text-sm font-medium text-secondary-text mb-2">
//                     Phone Number
//                   </label>
//                   <input
//                     type="tel"
//                     name="phone"
//                     value={profile.phone}
//                     onChange={handleProfileChange}
//                     className="
//                       w-full px-5 py-3 rounded-xl border border-card-border
//                       bg-secondary-bg text-primary-text
//                       focus:border-accent-orange-500 focus:ring-2 focus:ring-accent-orange-500/20
//                     "
//                   />
//                 </div>
//               </div>

//               <div className="flex justify-end">
//                 <button
//                   onClick={handleSaveProfile}
//                   className="
//                     flex items-center gap-2 px-6 py-3 
//                     bg-gradient-to-r from-accent-orange-600 to-accent-orange-700
//                     hover:from-accent-orange-700 hover:to-accent-orange-800
//                     text-white font-medium rounded-xl shadow-lg transition-all
//                   "
//                 >
//                   <Save className="w-4 h-4" />
//                   Save Changes
//                 </button>
//               </div>
//             </div>
//           </div>

//           {/* Notifications */}
//           <div className="bg-card-bg rounded-2xl border border-card-border shadow-2xl overflow-hidden">
//             <div className="px-8 py-6 border-b border-card-border bg-secondary-bg">
//               <h2 className="text-xl font-semibold flex items-center gap-3">
//                 <Bell className="w-5 h-5 text-accent-orange-400" />
//                 Notifications
//               </h2>
//             </div>
//             <div className="p-8 space-y-5">
//               {[
//                 { key: "email", label: "Email Notifications", desc: "Receive important updates via email" },
//                 { key: "push", label: "Push Notifications", desc: "Get real-time alerts on your device" },
//                 {
//                   key: "transactionAlerts",
//                   label: "Transaction Alerts",
//                   desc: "Notify on every new transaction",
//                 },
//               ].map((item) => (
//                 <div key={item.key} className="flex items-center justify-between">
//                   <div>
//                     <p className="font-medium text-primary-text">{item.label}</p>
//                     <p className="text-sm text-secondary-text">{item.desc}</p>
//                   </div>
//                   <label className="relative inline-flex items-center cursor-pointer">
//                     <input
//                       type="checkbox"
//                       checked={notifications[item.key]}
//                       onChange={() => handleNotificationChange(item.key)}
//                       className="sr-only peer"
//                     />
//                     <div
//                       className="
//                         w-11 h-6 bg-gray-700 peer-focus:outline-none 
//                         peer-focus:ring-2 peer-focus:ring-accent-orange-500/30 
//                         rounded-full peer peer-checked:bg-accent-orange-600
//                         after:content-[''] after:absolute after:top-[2px] after:left-[2px]
//                         after:bg-white after:rounded-full after:h-5 after:w-5 
//                         after:transition-all after:shadow-md
//                         peer-checked:after:translate-x-5
//                       "
//                     ></div>
//                   </label>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Security */}
//           <div className="bg-card-bg rounded-2xl border border-card-border shadow-2xl overflow-hidden">
//             <div className="px-8 py-6 border-b border-card-border bg-secondary-bg">
//               <h2 className="text-xl font-semibold flex items-center gap-3">
//                 <ShieldCheck className="w-5 h-5 text-accent-orange-400" />
//                 Security
//               </h2>
//             </div>
//             <div className="p-8 space-y-6">
//               <div className="flex items-center justify-between">
//                 <div>
//                   <p className="font-medium text-primary-text">Two-Factor Authentication</p>
//                   <p className="text-sm text-secondary-text">Add an extra layer of security to your account</p>
//                 </div>
//                 <button className="px-5 py-2 bg-accent-orange-600 hover:bg-accent-orange-700 text-white rounded-xl transition">
//                   Enable 2FA
//                 </button>
//               </div>

//               <div className="pt-4 border-t border-card-border">
//                 <button className="text-loss-red hover:text-red-400 transition flex items-center gap-2">
//                   <Lock className="w-4 h-4" />
//                   Change Password
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Sidebar / Quick Info */}
//         <div className="space-y-6">
//           {/* Appearance */}
//           <div className="bg-card-bg rounded-2xl border border-card-border shadow-2xl p-6">
//             <h3 className="text-lg font-semibold mb-5 flex items-center gap-3">
//               <Moon className="w-5 h-5 text-accent-orange-400" />
//               Appearance
//             </h3>

//             <div className="flex flex-col gap-3">
//               <button
//                 onClick={() => theme !== "light" && toggleTheme()}
//                 className={`
//                   flex items-center justify-between p-4 rounded-xl border
//                   ${theme === "light"
//                     ? "border-accent-orange-500 bg-accent-orange-950/30"
//                     : "border-card-border hover:bg-accent-orange-950/20"}
//                 `}
//               >
//                 <div className="flex items-center gap-3">
//                   <Sun className="w-5 h-5" />
//                   <span>Light Mode</span>
//                 </div>
//                 {theme === "light" && <span className="text-accent-orange-400">Active</span>}
//               </button>

//               <button
//                 onClick={() => theme !== "dark" && toggleTheme()}
//                 className={`
//                   flex items-center justify-between p-4 rounded-xl border
//                   ${theme === "dark"
//                     ? "border-accent-orange-500 bg-accent-orange-950/30"
//                     : "border-card-border hover:bg-accent-orange-950/20"}
//                 `}
//               >
//                 <div className="flex items-center gap-3">
//                   <Moon className="w-5 h-5" />
//                   <span>Dark Mode</span>
//                 </div>
//                 {theme === "dark" && <span className="text-accent-orange-400">Active</span>}
//               </button>
//             </div>
//           </div>

//           {/* Currency & Region */}
//           <div className="bg-card-bg rounded-2xl border border-card-border shadow-2xl p-6">
//             <h3 className="text-lg font-semibold mb-5 flex items-center gap-3">
//               <Globe className="w-5 h-5 text-accent-orange-400" />
//               Currency & Region
//             </h3>

//             <div className="space-y-4">
//               <div>
//                 <label className="block text-sm text-secondary-text mb-2">Preferred Currency</label>
//                 <select
//                   defaultValue="INR"
//                   className="
//                     w-full px-5 py-3 rounded-xl border border-card-border
//                     bg-secondary-bg text-primary-text
//                   "
//                 >
//                   <option value="INR">INR - Indian Rupee</option>
//                   <option value="USD">USD - US Dollar</option>
//                   <option value="EUR">EUR - Euro</option>
//                 </select>
//               </div>

//               <div>
//                 <label className="block text-sm text-secondary-text mb-2">Time Zone</label>
//                 <select
//                   defaultValue="Asia/Kolkata"
//                   className="
//                     w-full px-5 py-3 rounded-xl border border-card-border
//                     bg-secondary-bg text-primary-text
//                   "
//                 >
//                   <option value="Asia/Kolkata">Asia/Kolkata (IST)</option>
//                   <option value="America/New_York">America/New York (EST)</option>
//                   <option value="Europe/London">Europe/London (GMT)</option>
//                 </select>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// // src/pages/Settings.jsx
// import { useState } from "react";
// import { useTheme } from "../context/ThemeContext";
// import {
//   User,
//   Bell,
//   ShieldCheck,
//   Globe,
//   Moon,
//   Sun,
//   Lock,
//   Save,
//   IndianRupee,
//   Tag,
//   Plus,
//   Trash2,
// } from "lucide-react";

// export default function Settings() {
//   const { theme, toggleTheme } = useTheme();

//   // Profile
//   const [profile, setProfile] = useState({
//     name: "Admin User",
//     email: "admin@onedesk.com",
//     phone: "+91 98765 43210",
//   });

//   // Notifications
//   const [notifications, setNotifications] = useState({
//     email: true,
//     push: true,
//     transactionAlerts: true,
//   });

//   // Card Pricing
//   const [cardPricing, setCardPricing] = useState({
//     pricePerCard: 110.00,
//     minCards: 10,
//   });

//   // Coupons
//   const [coupons, setCoupons] = useState([
//     { id: 1, code: "WELCOME10", discount: 10, active: true },
//     { id: 2, code: "FIRST50", discount: 50, active: true },
//     { id: 3, code: "ONEDESK10", discount: 10, active: false },
//   ]);

//   const [newCoupon, setNewCoupon] = useState({ code: "", discount: "" });

//   // Handlers
//   const handleProfileChange = (e) => {
//     const { name, value } = e.target;
//     setProfile((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleNotificationChange = (key) => {
//     setNotifications((prev) => ({ ...prev, [key]: !prev[key] }));
//   };

//   const handlePricingChange = (e) => {
//     const { name, value } = e.target;
//     setCardPricing((prev) => ({
//       ...prev,
//       [name]: name === "pricePerCard" ? parseFloat(value) || 0 : parseInt(value) || 0,
//     }));
//   };

//   const handleSavePricing = () => {
//     alert(`✅ Pricing Updated!\nPrice per card: ₹${cardPricing.pricePerCard}\nMinimum cards: ${cardPricing.minCards}`);
//   };

//   const handleAddCoupon = () => {
//     if (!newCoupon.code.trim() || !newCoupon.discount) {
//       alert("Please enter coupon code and discount percentage");
//       return;
//     }

//     const coupon = {
//       id: Date.now(),
//       code: newCoupon.code.toUpperCase().trim(),
//       discount: parseInt(newCoupon.discount),
//       active: true,
//     };

//     setCoupons((prev) => [...prev, coupon]);
//     setNewCoupon({ code: "", discount: "" });
//     alert(`✅ Coupon ${coupon.code} added successfully!`);
//   };

//   const toggleCoupon = (id) => {
//     setCoupons((prev) =>
//       prev.map((c) => (c.id === id ? { ...c, active: !c.active } : c))
//     );
//   };

//   const deleteCoupon = (id) => {
//     if (window.confirm("Delete this coupon?")) {
//       setCoupons((prev) => prev.filter((c) => c.id !== id));
//     }
//   };

//   const handleSaveProfile = () => {
//     alert("Profile updated successfully!");
//   };

//   return (
//     <div className="p-6 lg:p-8 max-w-7xl mx-auto space-y-8">
//       <div>
//         <h1 className="text-3xl font-bold text-white">Settings</h1>
//         <p className="text-gray-400 mt-1">Manage your account preferences and security</p>
//       </div>

//       <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
//         {/* Main Content - Left Side */}
//         <div className="lg:col-span-8 space-y-6">
//           {/* Profile Information */}
//           <div className="bg-[#1F1F1F] border border-gray-800 rounded-3xl p-8">
//             <h2 className="text-xl font-semibold flex items-center gap-3 mb-6">
//               <User className="w-5 h-5 text-orange-500" />
//               Profile Information
//             </h2>

//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//               <div>
//                 <label className="block text-sm text-gray-400 mb-2">Full Name</label>
//                 <input
//                   type="text"
//                   name="name"
//                   value={profile.name}
//                   onChange={handleProfileChange}
//                   className="w-full bg-[#2A2A2A] border border-gray-700 rounded-2xl px-5 py-3 text-white focus:border-orange-500 focus:outline-none"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm text-gray-400 mb-2">Email Address</label>
//                 <input
//                   type="email"
//                   name="email"
//                   value={profile.email}
//                   onChange={handleProfileChange}
//                   className="w-full bg-[#2A2A2A] border border-gray-700 rounded-2xl px-5 py-3 text-white focus:border-orange-500 focus:outline-none"
//                 />
//               </div>
//               <div className="md:col-span-2">
//                 <label className="block text-sm text-gray-400 mb-2">Phone Number</label>
//                 <input
//                   type="tel"
//                   name="phone"
//                   value={profile.phone}
//                   onChange={handleProfileChange}
//                   className="w-full bg-[#2A2A2A] border border-gray-700 rounded-2xl px-5 py-3 text-white focus:border-orange-500 focus:outline-none"
//                 />
//               </div>
//             </div>

//             <div className="flex justify-end mt-8">
//               <button
//                 onClick={handleSaveProfile}
//                 className="flex items-center gap-2 bg-orange-600 hover:bg-orange-700 px-8 py-3 rounded-2xl font-medium transition"
//               >
//                 <Save className="w-4 h-4" />
//                 Save Changes
//               </button>
//             </div>
//           </div>

//           {/* Notifications */}
//           <div className="bg-[#1F1F1F] border border-gray-800 rounded-3xl p-8">
//             <h2 className="text-xl font-semibold flex items-center gap-3 mb-6">
//               <Bell className="w-5 h-5 text-orange-500" />
//               Notifications
//             </h2>

//             <div className="space-y-6">
//               {[
//                 { key: "email", label: "Email Notifications", desc: "Receive important updates via email" },
//                 { key: "push", label: "Push Notifications", desc: "Get real-time alerts on your device" },
//                 { key: "transactionAlerts", label: "Transaction Alerts", desc: "Notify on every new transaction" },
//               ].map((item) => (
//                 <div key={item.key} className="flex items-center justify-between py-2">
//                   <div>
//                     <p className="font-medium text-white">{item.label}</p>
//                     <p className="text-sm text-gray-400">{item.desc}</p>
//                   </div>
//                   <label className="relative inline-flex items-center cursor-pointer">
//                     <input
//                       type="checkbox"
//                       checked={notifications[item.key]}
//                       onChange={() => handleNotificationChange(item.key)}
//                       className="sr-only peer"
//                     />
//                     <div className="w-11 h-6 bg-gray-700 peer-focus:outline-none peer-focus:ring-2 peer-focus:ring-orange-500 rounded-full peer peer-checked:bg-orange-600 after:content-[''] after:absolute after:top-0.5 after:left-0.5 after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:after:translate-x-5"></div>
//                   </label>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Security */}
//           <div className="bg-[#1F1F1F] border border-gray-800 rounded-3xl p-8">
//             <h2 className="text-xl font-semibold flex items-center gap-3 mb-6">
//               <ShieldCheck className="w-5 h-5 text-orange-500" />
//               Security
//             </h2>
//             <div className="space-y-6">
//               <div className="flex justify-between items-center">
//                 <div>
//                   <p className="font-medium text-white">Two-Factor Authentication</p>
//                   <p className="text-sm text-gray-400">Add an extra layer of security to your account</p>
//                 </div>
//                 <button className="bg-orange-600 hover:bg-orange-700 px-6 py-2.5 rounded-2xl text-sm font-medium">
//                   Enable 2FA
//                 </button>
//               </div>
//               <div className="pt-4 border-t border-gray-800">
//                 <button className="flex items-center gap-2 text-red-400 hover:text-red-500 transition">
//                   <Lock className="w-4 h-4" />
//                   Change Password
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Right Sidebar */}
//         <div className="lg:col-span-4 space-y-6">
//           {/* Appearance */}
//           {/* <div className="bg-[#1F1F1F] border border-gray-800 rounded-3xl p-6">
//             <h3 className="text-lg font-semibold mb-5 flex items-center gap-3">
//               <Moon className="w-5 h-5 text-orange-500" />
//               Appearance
//             </h3>
//             <div className="space-y-3">
//               <button
//                 onClick={() => theme !== "light" && toggleTheme()}
//                 className={`w-full flex items-center justify-between p-4 rounded-2xl border transition ${theme === "light" ? "border-orange-500 bg-orange-950/30" : "border-gray-700 hover:bg-gray-800"}`}
//               >
//                 <div className="flex items-center gap-3">
//                   <Sun className="w-5 h-5" />
//                   Light Mode
//                 </div>
//                 {theme === "light" && <span className="text-orange-500 text-sm">Active</span>}
//               </button>

//               <button
//                 onClick={() => theme !== "dark" && toggleTheme()}
//                 className={`w-full flex items-center justify-between p-4 rounded-2xl border transition ${theme === "dark" ? "border-orange-500 bg-orange-950/30" : "border-gray-700 hover:bg-gray-800"}`}
//               >
//                 <div className="flex items-center gap-3">
//                   <Moon className="w-5 h-5" />
//                   Dark Mode
//                 </div>
//                 {theme === "dark" && <span className="text-orange-500 text-sm">Active</span>}
//               </button>
//             </div>
//           </div> */}

//           {/* Currency & Region */}
//           {/* <div className="bg-[#1F1F1F] border border-gray-800 rounded-3xl p-6">
//             <h3 className="text-lg font-semibold mb-5 flex items-center gap-3">
//               <Globe className="w-5 h-5 text-orange-500" />
//               Currency & Region
//             </h3>
//             <div className="space-y-5">
//               <div>
//                 <label className="block text-sm text-gray-400 mb-2">Preferred Currency</label>
//                 <select className="w-full bg-[#2A2A2A] border border-gray-700 rounded-2xl px-5 py-3 text-white focus:border-orange-500">
//                   <option>INR - Indian Rupee</option>
//                 </select>
//               </div>
//               <div>
//                 <label className="block text-sm text-gray-400 mb-2">Time Zone</label>
//                 <select className="w-full bg-[#2A2A2A] border border-gray-700 rounded-2xl px-5 py-3 text-white focus:border-orange-500">
//                   <option>Asia/Kolkata (IST)</option>
//                 </select>
//               </div>
//             </div>
//           </div> */}

//           {/* Card Pricing */}
//           <div className="bg-[#1F1F1F] border border-gray-800 rounded-3xl p-6">
//             <h3 className="text-lg font-semibold mb-5 flex items-center gap-3">
//               <IndianRupee className="w-5 h-5 text-orange-500" />
//               Card Pricing
//             </h3>
//             <div className="space-y-5">
//               <div>
//                 <label className="block text-sm text-gray-400 mb-2">Price per card (₹)</label>
//                 <input
//                   type="number"
//                   name="pricePerCard"
//                   value={cardPricing.pricePerCard}
//                   onChange={handlePricingChange}
//                   step="0.01"
//                   className="w-full bg-[#2A2A2A] border border-gray-700 rounded-2xl px-5 py-3 text-white focus:border-orange-500"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm text-gray-400 mb-2">Minimum cards per purchase</label>
//                 <input
//                   type="number"
//                   name="minCards"
//                   value={cardPricing.minCards}
//                   onChange={handlePricingChange}
//                   className="w-full bg-[#2A2A2A] border border-gray-700 rounded-2xl px-5 py-3 text-white focus:border-orange-500"
//                 />
//               </div>
//               <button
//                 onClick={handleSavePricing}
//                 className="w-full bg-orange-600 hover:bg-orange-700 py-3 rounded-2xl font-medium transition"
//               >
//                 Save Pricing
//               </button>
//             </div>
//           </div>

//           {/* Coupon Management */}
//           <div className="bg-[#1F1F1F] border border-gray-800 rounded-3xl p-6">
//             <h3 className="text-lg font-semibold mb-5 flex items-center gap-3">
//               <Tag className="w-5 h-5 text-orange-500" />
//               Coupon Management
//             </h3>

//             {/* Add New Coupon */}
//             <div className="flex gap-3 mb-6">
//               <input
//                 type="text"
//                 placeholder="Coupon Code"
//                 value={newCoupon.code}
//                 onChange={(e) => setNewCoupon({ ...newCoupon, code: e.target.value })}
//                 className="flex-1 bg-[#2A2A2A] border border-gray-700 rounded-2xl px-4 py-3 text-white focus:border-orange-500"
//               />
//               <input
//                 type="number"
//                 placeholder="%"
//                 value={newCoupon.discount}
//                 onChange={(e) => setNewCoupon({ ...newCoupon, discount: e.target.value })}
//                 className="w-20 bg-[#2A2A2A] border border-gray-700 rounded-2xl px-4 py-3 text-white focus:border-orange-500"
//               />
//               <button
//                 onClick={handleAddCoupon}
//                 className="bg-orange-600 hover:bg-orange-700 px-5 rounded-2xl"
//               >
//                 <Plus className="w-5 h-5" />
//               </button>
//             </div>

//             {/* Coupon List */}
//             <div className="space-y-3">
//               {coupons.map((coupon) => (
//                 <div key={coupon.id} className="flex items-center justify-between bg-[#2A2A2A] border border-gray-700 rounded-2xl px-5 py-4">
//                   <div>
//                     <p className="font-medium text-white">{coupon.code}</p>
//                     <p className="text-sm text-gray-400">{coupon.discount}% OFF</p>
//                   </div>
//                   <div className="flex items-center gap-3">
//                     <button
//                       onClick={() => toggleCoupon(coupon.id)}
//                       className={`text-xs px-4 py-1 rounded-xl font-medium ${coupon.active ? "bg-green-600 text-white" : "bg-gray-600 text-gray-300"}`}
//                     >
//                       {coupon.active ? "Active" : "Inactive"}
//                     </button>
//                     <button
//                       onClick={() => deleteCoupon(coupon.id)}
//                       className="text-red-400 hover:text-red-500"
//                     >
//                       <Trash2 className="w-4 h-4" />
//                     </button>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// // src/pages/Settings.jsx
// import { useState } from "react";
// import { useTheme } from "../context/ThemeContext";
// import {
//   User,
//   Bell,
//   ShieldCheck,
//   Globe,
//   Moon,
//   Sun,
//   Lock,
//   Save,
//   Tag,
//   Plus,
//   Trash2,
//   Calendar,
// } from "lucide-react";

// export default function Settings() {
//   const { theme, toggleTheme } = useTheme();

//   // Profile State
//   const [profile, setProfile] = useState({
//     name: "Admin User",
//     email: "admin@onedesk.com",
//     phone: "+91 98765 43210",
//   });

//   // Notifications State
//   const [notifications, setNotifications] = useState({
//     email: true,
//     push: true,
//     transactionAlerts: true,
//   });

//   // Custom Package Pricing State
//   const [packages, setPackages] = useState([
//     { id: 1, name: "Trial Package", validityDays: 30, pricePerCard: 110 },
//     { id: 2, name: "Annual Package", validityDays: 365, pricePerCard: 99 },
//     { id: 3, name: "Biennial Package", validityDays: 730, pricePerCard: 89 },
//   ]);

//   const [newPackage, setNewPackage] = useState({
//     name: "",
//     validityDays: "",
//     pricePerCard: "",
//   });

//   // Coupon State
//   const [coupons, setCoupons] = useState([
//     { id: 1, code: "WELCOME10", discount: 10, active: true },
//     { id: 2, code: "FIRST50", discount: 50, active: true },
//     { id: 3, code: "ONEDESK10", discount: 10, active: false },
//   ]);

//   const [newCoupon, setNewCoupon] = useState({ code: "", discount: "" });

//   // Profile Handlers
//   const handleProfileChange = (e) => {
//     const { name, value } = e.target;
//     setProfile((prev) => ({ ...prev, [name]: value }));
//   };

//   const handleSaveProfile = () => {
//     alert("✅ Profile updated successfully!");
//   };

//   // Notification Handlers
//   const handleNotificationChange = (key) => {
//     setNotifications((prev) => ({ ...prev, [key]: !prev[key] }));
//   };

//   // Package Pricing Handlers
//   const handleAddPackage = () => {
//     if (!newPackage.name.trim() || !newPackage.validityDays || !newPackage.pricePerCard) {
//       alert("Please fill all fields for the new package");
//       return;
//     }

//     const pkg = {
//       id: Date.now(),
//       name: newPackage.name.trim(),
//       validityDays: parseInt(newPackage.validityDays),
//       pricePerCard: parseFloat(newPackage.pricePerCard),
//     };

//     setPackages((prev) => [...prev, pkg]);
//     setNewPackage({ name: "", validityDays: "", pricePerCard: "" });
//     alert(`✅ Package "${pkg.name}" added successfully!`);
//   };

//   const handlePackageChange = (id, field, value) => {
//     setPackages((prev) =>
//       prev.map((pkg) =>
//         pkg.id === id
//           ? { ...pkg, [field]: field === "pricePerCard" ? parseFloat(value) || 0 : value }
//           : pkg
//       )
//     );
//   };

//   const handleDeletePackage = (id) => {
//     if (window.confirm("Are you sure you want to delete this package?")) {
//       setPackages((prev) => prev.filter((p) => p.id !== id));
//     }
//   };

//   const handleSavePackagePricing = () => {
//     alert("✅ All Package Pricing saved successfully!");
//     console.log("Saved Packages:", packages);
//   };

//   // Coupon Handlers
//   const handleAddCoupon = () => {
//     if (!newCoupon.code.trim() || !newCoupon.discount) {
//       alert("Please enter coupon code and discount percentage");
//       return;
//     }

//     const coupon = {
//       id: Date.now(),
//       code: newCoupon.code.toUpperCase().trim(),
//       discount: parseInt(newCoupon.discount),
//       active: true,
//     };

//     setCoupons((prev) => [...prev, coupon]);
//     setNewCoupon({ code: "", discount: "" });
//     alert(`✅ Coupon ${coupon.code} added successfully!`);
//   };

//   const toggleCoupon = (id) => {
//     setCoupons((prev) =>
//       prev.map((c) => (c.id === id ? { ...c, active: !c.active } : c))
//     );
//   };

//   const deleteCoupon = (id) => {
//     if (window.confirm("Delete this coupon?")) {
//       setCoupons((prev) => prev.filter((c) => c.id !== id));
//     }
//   };

//   return (
//     <div className="p-6 lg:p-8 max-w-7xl mx-auto space-y-8">
//       <div>
//         <h1 className="text-3xl font-bold text-white">Settings</h1>
//         <p className="text-gray-400 mt-1">Manage your account preferences and security</p>
//       </div>

//       <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
//         {/* Left Side - Profile, Notifications, Security */}
//         <div className="lg:col-span-8 space-y-6">
//           {/* Profile Information */}
//           <div className="bg-[#1F1F1F] border border-gray-800 rounded-3xl p-8">
//             <h2 className="text-xl font-semibold flex items-center gap-3 mb-6">
//               <User className="w-5 h-5 text-orange-500" />
//               Profile Information
//             </h2>
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//               <div>
//                 <label className="block text-sm text-gray-400 mb-2">Full Name</label>
//                 <input
//                   type="text"
//                   name="name"
//                   value={profile.name}
//                   onChange={handleProfileChange}
//                   className="w-full bg-[#2A2A2A] border border-gray-700 rounded-2xl px-5 py-3 text-white focus:border-orange-500 focus:outline-none"
//                 />
//               </div>
//               <div>
//                 <label className="block text-sm text-gray-400 mb-2">Email Address</label>
//                 <input
//                   type="email"
//                   name="email"
//                   value={profile.email}
//                   onChange={handleProfileChange}
//                   className="w-full bg-[#2A2A2A] border border-gray-700 rounded-2xl px-5 py-3 text-white focus:border-orange-500 focus:outline-none"
//                 />
//               </div>
//               <div className="md:col-span-2">
//                 <label className="block text-sm text-gray-400 mb-2">Phone Number</label>
//                 <input
//                   type="tel"
//                   name="phone"
//                   value={profile.phone}
//                   onChange={handleProfileChange}
//                   className="w-full bg-[#2A2A2A] border border-gray-700 rounded-2xl px-5 py-3 text-white focus:border-orange-500 focus:outline-none"
//                 />
//               </div>
//             </div>
//             <div className="flex justify-end mt-8">
//               <button
//                 onClick={handleSaveProfile}
//                 className="bg-orange-600 hover:bg-orange-700 px-8 py-3 rounded-2xl font-medium transition flex items-center gap-2"
//               >
//                 <Save className="w-4 h-4" />
//                 Save Changes
//               </button>
//             </div>
//           </div>

//           {/* Notifications */}
//           <div className="bg-[#1F1F1F] border border-gray-800 rounded-3xl p-8">
//             <h2 className="text-xl font-semibold flex items-center gap-3 mb-6">
//               <Bell className="w-5 h-5 text-orange-500" />
//               Notifications
//             </h2>
//             <div className="space-y-6">
//               {[
//                 { key: "email", label: "Email Notifications", desc: "Receive important updates via email" },
//                 { key: "push", label: "Push Notifications", desc: "Get real-time alerts on your device" },
//                 { key: "transactionAlerts", label: "Transaction Alerts", desc: "Notify on every new transaction" },
//               ].map((item) => (
//                 <div key={item.key} className="flex items-center justify-between py-3">
//                   <div>
//                     <p className="font-medium text-white">{item.label}</p>
//                     <p className="text-sm text-gray-400">{item.desc}</p>
//                   </div>
//                   <label className="relative inline-flex items-center cursor-pointer">
//                     <input
//                       type="checkbox"
//                       checked={notifications[item.key]}
//                       onChange={() => handleNotificationChange(item.key)}
//                       className="sr-only peer"
//                     />
//                     <div className="w-11 h-6 bg-gray-700 rounded-full peer peer-checked:bg-orange-600 after:content-[''] after:absolute after:top-0.5 after:left-0.5 after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:after:translate-x-5"></div>
//                   </label>
//                 </div>
//               ))}
//             </div>
//           </div>

//           {/* Security */}
//           <div className="bg-[#1F1F1F] border border-gray-800 rounded-3xl p-8">
//             <h2 className="text-xl font-semibold flex items-center gap-3 mb-6">
//               <ShieldCheck className="w-5 h-5 text-orange-500" />
//               Security
//             </h2>
//             <div className="space-y-6">
//               <div className="flex justify-between items-center">
//                 <div>
//                   <p className="font-medium text-white">Two-Factor Authentication</p>
//                   <p className="text-sm text-gray-400">Add an extra layer of security to your account</p>
//                 </div>
//                 <button className="bg-orange-600 hover:bg-orange-700 px-6 py-2.5 rounded-2xl text-sm font-medium">
//                   Enable 2FA
//                 </button>
//               </div>
//               <div className="pt-4 border-t border-gray-800">
//                 <button className="flex items-center gap-2 text-red-400 hover:text-red-500 transition">
//                   <Lock className="w-4 h-4" />
//                   Change Password
//                 </button>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Right Sidebar */}
//         <div className="lg:col-span-4 space-y-6">
          

         

//           {/* ==================== PACKAGE PRICING ==================== */}
//           <div className="bg-[#1F1F1F] border border-gray-800 rounded-3xl p-6">
//             <h3 className="text-lg font-semibold mb-6 flex items-center gap-3">
//               <Calendar className="w-5 h-5 text-orange-500" />
//               Package Pricing
//             </h3>

//             {/* Add New Package */}
//             <div className="bg-[#2A2A2A] border border-gray-700 rounded-2xl p-5 mb-6">
//               <h4 className="text-sm font-medium mb-4 text-gray-300">Add New Package</h4>
//               <div className="space-y-4">
//                 <input
//                   type="text"
//                   placeholder="Package Name (e.g. Premium Yearly)"
//                   value={newPackage.name}
//                   onChange={(e) => setNewPackage({ ...newPackage, name: e.target.value })}
//                   className="w-full bg-[#1F1F1F] border border-gray-700 rounded-xl px-4 py-3 text-white focus:border-orange-500"
//                 />
//                 <div className="grid grid-cols-2 gap-4">
//                   <div>
//                     <label className="block text-xs text-gray-400 mb-1">Validity (Days)</label>
//                     <input
//                       type="number"
//                       placeholder="365"
//                       value={newPackage.validityDays}
//                       onChange={(e) => setNewPackage({ ...newPackage, validityDays: e.target.value })}
//                       className="w-full bg-[#1F1F1F] border border-gray-700 rounded-xl px-4 py-3 text-white focus:border-orange-500"
//                     />
//                   </div>
//                   <div>
//                     <label className="block text-xs text-gray-400 mb-1">Price per Card (₹)</label>
//                     <input
//                       type="number"
//                       step="0.01"
//                       placeholder="99.00"
//                       value={newPackage.pricePerCard}
//                       onChange={(e) => setNewPackage({ ...newPackage, pricePerCard: e.target.value })}
//                       className="w-full bg-[#1F1F1F] border border-gray-700 rounded-xl px-4 py-3 text-white focus:border-orange-500"
//                     />
//                   </div>
//                 </div>
//                 <button
//                   onClick={handleAddPackage}
//                   className="w-full bg-orange-600 hover:bg-orange-700 py-3 rounded-xl font-medium flex items-center justify-center gap-2"
//                 >
//                   <Plus className="w-4 h-4" /> Add Package
//                 </button>
//               </div>
//             </div>

//             {/* Package List */}
//             <div className="space-y-4">
//               {packages.map((pkg) => (
//                 <div key={pkg.id} className="bg-[#2A2A2A] border border-gray-700 rounded-2xl p-5">
//                   <div className="flex justify-between items-start mb-4">
//                     <div>
//                       <p className="font-semibold text-white">{pkg.name}</p>
//                       <p className="text-sm text-gray-400">{pkg.validityDays} Days Validity</p>
//                     </div>
//                     <button
//                       onClick={() => handleDeletePackage(pkg.id)}
//                       className="text-red-400 hover:text-red-500 p-1"
//                     >
//                       <Trash2 className="w-4 h-4" />
//                     </button>
//                   </div>

//                   <div>
//                     <label className="block text-xs text-gray-400 mb-1">Price per Card (₹)</label>
//                     <input
//                       type="number"
//                       step="0.01"
//                       value={pkg.pricePerCard}
//                       onChange={(e) => handlePackageChange(pkg.id, "pricePerCard", e.target.value)}
//                       className="w-full bg-[#1F1F1F] border border-gray-700 rounded-xl px-4 py-3 text-white focus:border-orange-500"
//                     />
//                   </div>
//                 </div>
//               ))}
//             </div>

//             <button
//               onClick={handleSavePackagePricing}
//               className="mt-6 w-full bg-orange-600 hover:bg-orange-700 py-3.5 rounded-2xl font-medium transition"
//             >
//               Save All Package Pricing
//             </button>
//           </div>

//           {/* Coupon Management */}
//           <div className="bg-[#1F1F1F] border border-gray-800 rounded-3xl p-6">
//             <h3 className="text-lg font-semibold mb-5 flex items-center gap-3">
//               <Tag className="w-5 h-5 text-orange-500" />
//               Coupon Management
//             </h3>

//             <div className="flex gap-3 mb-6">
//               <input
//                 type="text"
//                 placeholder="Coupon Code"
//                 value={newCoupon.code}
//                 onChange={(e) => setNewCoupon({ ...newCoupon, code: e.target.value })}
//                 className="flex-1 bg-[#2A2A2A] border border-gray-700 rounded-2xl px-4 py-3 text-white focus:border-orange-500"
//               />
//               <input
//                 type="number"
//                 placeholder="%"
//                 value={newCoupon.discount}
//                 onChange={(e) => setNewCoupon({ ...newCoupon, discount: e.target.value })}
//                 className="w-20 bg-[#2A2A2A] border border-gray-700 rounded-2xl px-4 py-3 text-white focus:border-orange-500"
//               />
//               <button
//                 onClick={handleAddCoupon}
//                 className="bg-orange-600 hover:bg-orange-700 px-5 rounded-2xl"
//               >
//                 <Plus className="w-5 h-5" />
//               </button>
//             </div>

//             <div className="space-y-3">
//               {coupons.map((coupon) => (
//                 <div key={coupon.id} className="flex items-center justify-between bg-[#2A2A2A] border border-gray-700 rounded-2xl px-5 py-4">
//                   <div>
//                     <p className="font-medium text-white">{coupon.code}</p>
//                     <p className="text-sm text-gray-400">{coupon.discount}% Discount</p>
//                   </div>
//                   <div className="flex items-center gap-3">
//                     <button
//                       onClick={() => toggleCoupon(coupon.id)}
//                       className={`text-xs px-4 py-1 rounded-xl font-medium ${coupon.active ? "bg-green-600 text-white" : "bg-gray-600 text-gray-300"}`}
//                     >
//                       {coupon.active ? "Active" : "Inactive"}
//                     </button>
//                     <button
//                       onClick={() => deleteCoupon(coupon.id)}
//                       className="text-red-400 hover:text-red-500"
//                     >
//                       <Trash2 className="w-4 h-4" />
//                     </button>
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }

// src/pages/Settings.jsx
import { useState } from "react";
import { useTheme } from "../context/ThemeContext";
import {
  User,
  Bell,
  ShieldCheck,
  Globe,
  Moon,
  Sun,
  Lock,
  Save,
  Tag,
  Plus,
  Trash2,
  Calendar,
} from "lucide-react";

export default function Settings() {
  const { theme, toggleTheme } = useTheme();

  // Profile State
  const [profile, setProfile] = useState({
    name: "Admin User",
    email: "admin@onedesk.com",
    phone: "+91 98765 43210",
  });

  // Notifications State
  const [notifications, setNotifications] = useState({
    email: true,
    push: true,
    transactionAlerts: true,
  });

  // Custom Package Pricing State
  const [packages, setPackages] = useState([
    { id: 1, name: "Trial Package", validityDays: 30, pricePerCard: 110 },
    { id: 2, name: "Annual Package", validityDays: 365, pricePerCard: 99 },
    { id: 3, name: "Biennial Package", validityDays: 730, pricePerCard: 89 },
  ]);

  const [newPackage, setNewPackage] = useState({
    name: "",
    validityDays: "",
    pricePerCard: "",
  });

  // Coupon State
  const [coupons, setCoupons] = useState([
    { id: 1, code: "WELCOME10", discount: 10, active: true },
    { id: 2, code: "FIRST50", discount: 50, active: true },
    { id: 3, code: "ONEDESK10", discount: 10, active: false },
  ]);

  const [newCoupon, setNewCoupon] = useState({ code: "", discount: "" });

  // Profile Handlers
  const handleProfileChange = (e) => {
    const { name, value } = e.target;
    setProfile((prev) => ({ ...prev, [name]: value }));
  };

  const handleSaveProfile = () => {
    alert("✅ Profile updated successfully!");
  };

  // Notification Handlers
  const handleNotificationChange = (key) => {
    setNotifications((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  // Package Pricing Handlers
  const handleAddPackage = () => {
    if (!newPackage.name.trim() || !newPackage.validityDays || !newPackage.pricePerCard) {
      alert("Please fill all fields for the new package");
      return;
    }

    const pkg = {
      id: Date.now(),
      name: newPackage.name.trim(),
      validityDays: parseInt(newPackage.validityDays),
      pricePerCard: parseFloat(newPackage.pricePerCard),
    };

    setPackages((prev) => [...prev, pkg]);
    setNewPackage({ name: "", validityDays: "", pricePerCard: "" });
    alert(`✅ Package "${pkg.name}" added successfully!`);
  };

  const handlePackageChange = (id, field, value) => {
    setPackages((prev) =>
      prev.map((pkg) =>
        pkg.id === id
          ? { ...pkg, [field]: field === "pricePerCard" ? parseFloat(value) || 0 : value }
          : pkg
      )
    );
  };

  const handleDeletePackage = (id) => {
    if (window.confirm("Are you sure you want to delete this package?")) {
      setPackages((prev) => prev.filter((p) => p.id !== id));
    }
  };

  const handleSavePackagePricing = () => {
    alert("✅ All Package Pricing saved successfully!");
  };

  // Coupon Handlers
  const handleAddCoupon = () => {
    if (!newCoupon.code.trim() || !newCoupon.discount) {
      alert("Please enter coupon code and discount percentage");
      return;
    }

    const coupon = {
      id: Date.now(),
      code: newCoupon.code.toUpperCase().trim(),
      discount: parseInt(newCoupon.discount),
      active: true,
    };

    setCoupons((prev) => [...prev, coupon]);
    setNewCoupon({ code: "", discount: "" });
    alert(`✅ Coupon ${coupon.code} added successfully!`);
  };

  const toggleCoupon = (id) => {
    setCoupons((prev) =>
      prev.map((c) => (c.id === id ? { ...c, active: !c.active } : c))
    );
  };

  const deleteCoupon = (id) => {
    if (window.confirm("Delete this coupon?")) {
      setCoupons((prev) => prev.filter((c) => c.id !== id));
    }
  };

  // Dynamic Classes based on Theme
  const isDark = theme === "dark";

  const cardBg = isDark ? "bg-black" : "bg-white border-gray-200";
  const inputBg = isDark ? "bg-[#000000] border-gray-700" : "bg-gray-50 border-gray-300";
  const textPrimary = isDark ? "text-white" : "text-gray-900";
  const textSecondary = isDark ? "text-gray-400" : "text-gray-500";
  const buttonPrimary = "bg-orange-600 hover:bg-orange-700 text-white";

  return (
    <div className={`p-6 lg:p-8 max-w-7xl mx-auto space-y-8 ${isDark ? "bg-black" : "bg-gray-50"}`}>
      <div>
        <h1 className={`text-3xl font-bold ${textPrimary}`}>Settings</h1>
        <p className={`mt-1 ${textSecondary}`}>Manage your account preferences and security</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
        {/* Left Side */}
        <div className="lg:col-span-8 space-y-6">
          {/* Profile Information */}
          <div className={`${inputBg} border rounded-3xl p-8`}>
            <h2 className={`text-xl font-semibold flex items-center gap-3 mb-6 ${textPrimary}`}>
              <User className="w-5 h-5 text-orange-500" />
              Profile Information
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className={`block text-sm mb-2 ${textSecondary}`}>Full Name</label>
                <input
                  type="text"
                  name="name"
                  value={profile.name}
                  onChange={handleProfileChange}
                  className={`w-full ${inputBg} border rounded-2xl px-5 py-3 focus:border-orange-500 focus:outline-none ${textPrimary}`}
                />
              </div>
              <div>
                <label className={`block text-sm mb-2 ${textSecondary}`}>Email Address</label>
                <input
                  type="email"
                  name="email"
                  value={profile.email}
                  onChange={handleProfileChange}
                  className={`w-full ${inputBg} border rounded-2xl px-5 py-3 focus:border-orange-500 focus:outline-none ${textPrimary}`}
                />
              </div>
              <div className="md:col-span-2">
                <label className={`block text-sm mb-2 ${textSecondary}`}>Phone Number</label>
                <input
                  type="tel"
                  name="phone"
                  value={profile.phone}
                  onChange={handleProfileChange}
                  className={`w-full ${inputBg} border rounded-2xl px-5 py-3 focus:border-orange-500 focus:outline-none ${textPrimary}`}
                />
              </div>
            </div>
            <div className="flex justify-end mt-8">
              <button
                onClick={handleSaveProfile}
                className={`${buttonPrimary} px-8 py-3 rounded-2xl font-medium transition flex items-center gap-2`}
              >
                <Save className="w-4 h-4" />
                Save Changes
              </button>
            </div>
          </div>

          {/* Notifications */}
          <div className={`${inputBg} border rounded-3xl p-8`}>
            <h2 className={`text-xl font-semibold flex items-center gap-3 mb-6 ${textPrimary}`}>
              <Bell className="w-5 h-5 text-orange-500" />
              Notifications
            </h2>
            <div className="space-y-6">
              {[
                { key: "email", label: "Email Notifications", desc: "Receive important updates via email" },
                { key: "push", label: "Push Notifications", desc: "Get real-time alerts on your device" },
                { key: "transactionAlerts", label: "Transaction Alerts", desc: "Notify on every new transaction" },
              ].map((item) => (
                <div key={item.key} className="flex items-center justify-between py-3">
                  <div>
                    <p className={`font-medium ${textPrimary}`}>{item.label}</p>
                    <p className={`text-sm ${textSecondary}`}>{item.desc}</p>
                  </div>
                  <label className="relative inline-flex items-center cursor-pointer">
                    <input
                      type="checkbox"
                      checked={notifications[item.key]}
                      onChange={() => handleNotificationChange(item.key)}
                      className="sr-only peer"
                    />
                    <div className="w-11 h-6 bg-gray-300 dark:bg-gray-700 rounded-full peer peer-checked:bg-orange-600 after:content-[''] after:absolute after:top-0.5 after:left-0.5 after:bg-white after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:after:translate-x-5"></div>
                  </label>
                </div>
              ))}
            </div>
          </div>

          {/* Security */}
          <div className={`${inputBg} border rounded-3xl p-8`}>
            <h2 className={`text-xl font-semibold flex items-center gap-3 mb-6 ${textPrimary}`}>
              <ShieldCheck className="w-5 h-5 text-orange-500" />
              Security
            </h2>
            <div className="space-y-6">
              <div className="flex justify-between items-center">
                <div>
                  <p className={`font-medium ${textPrimary}`}>Two-Factor Authentication</p>
                  <p className={`text-sm ${textSecondary}`}>Add an extra layer of security to your account</p>
                </div>
                <button className={`${buttonPrimary} px-6 py-2.5 rounded-2xl text-sm font-medium`}>
                  Enable 2FA
                </button>
              </div>
              <div className="pt-4 border-t border-gray-200 dark:border-gray-800">
                <button className="flex items-center gap-2 text-red-500 hover:text-red-600 transition">
                  <Lock className="w-4 h-4" />
                  Change Password
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Right Sidebar */}
        <div className="lg:col-span-4 space-y-6">
         
          {/* Package Pricing */}
          <div className={`${inputBg} border rounded-3xl p-6`}>
            <h3 className={`text-lg font-semibold mb-6 flex items-center gap-3 ${textPrimary}`}>
              <Calendar className="w-5 h-5 text-orange-500" />
              Package Pricing
            </h3>

            {/* Add New Package */}
            <div className={`${inputBg} border rounded-2xl p-5 mb-6`}>
              <h4 className={`text-sm font-medium mb-4 ${textSecondary}`}>Add New Package</h4>
              <div className="space-y-4">
                <input
                  type="text"
                  placeholder="Package Name"
                  value={newPackage.name}
                  onChange={(e) => setNewPackage({ ...newPackage, name: e.target.value })}
                  className={`w-full ${inputBg} border rounded-xl px-4 py-3 focus:border-orange-500 ${textPrimary}`}
                />
                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className={`block text-xs mb-1 ${textSecondary}`}>Validity (Days)</label>
                    <input
                      type="number"
                      placeholder="365"
                      value={newPackage.validityDays}
                      onChange={(e) => setNewPackage({ ...newPackage, validityDays: e.target.value })}
                      className={`w-full ${inputBg} border rounded-xl px-4 py-3 focus:border-orange-500 ${textPrimary}`}
                    />
                  </div>
                  <div>
                    <label className={`block text-xs mb-1 ${textSecondary}`}>Price per Card (₹)</label>
                    <input
                      type="number"
                      step="0.01"
                      placeholder="99.00"
                      value={newPackage.pricePerCard}
                      onChange={(e) => setNewPackage({ ...newPackage, pricePerCard: e.target.value })}
                      className={`w-full ${inputBg} border rounded-xl px-4 py-3 focus:border-orange-500 ${textPrimary}`}
                    />
                  </div>
                </div>
                <button
                  onClick={handleAddPackage}
                  className="w-full bg-orange-600 hover:bg-orange-700 py-3 rounded-xl font-medium flex items-center justify-center gap-2 text-white"
                >
                  <Plus className="w-4 h-4" /> Add Package
                </button>
              </div>
            </div>

            {/* Package List */}
            <div className="space-y-4">
              {packages.map((pkg) => (
                <div key={pkg.id} className={`${inputBg} border rounded-2xl p-5`}>
                  <div className="flex justify-between items-start mb-4">
                    <div>
                      <p className={`font-semibold ${textPrimary}`}>{pkg.name}</p>
                      <p className={`text-sm ${textSecondary}`}>{pkg.validityDays} Days</p>
                    </div>
                    <button
                      onClick={() => handleDeletePackage(pkg.id)}
                      className="text-red-500 hover:text-red-600 p-1"
                    >
                      <Trash2 className="w-4 h-4" />
                    </button>
                  </div>
                  <div>
                    <label className={`block text-xs mb-1 ${textSecondary}`}>Price per Card (₹)</label>
                    <input
                      type="number"
                      step="0.01"
                      value={pkg.pricePerCard}
                      onChange={(e) => handlePackageChange(pkg.id, "pricePerCard", e.target.value)}
                      className={`w-full ${inputBg} border rounded-xl px-4 py-3 focus:border-orange-500 ${textPrimary}`}
                    />
                  </div>
                </div>
              ))}
            </div>

            <button
              onClick={handleSavePackagePricing}
              className="mt-6 w-full bg-orange-600 hover:bg-orange-700 py-3.5 rounded-2xl font-medium text-white transition"
            >
              Save All Package Pricing
            </button>
          </div>

          {/* Coupon Management */}
          <div className={`${inputBg} border rounded-3xl p-6`}>
            <h3 className={`text-lg font-semibold mb-5 flex items-center gap-3 ${textPrimary}`}>
              <Tag className="w-5 h-5 text-orange-500" />
              Coupon Management
            </h3>

            <div className="flex gap-3 mb-6">
              <input
                type="text"
                placeholder="Coupon Code"
                value={newCoupon.code}
                onChange={(e) => setNewCoupon({ ...newCoupon, code: e.target.value })}
                className={`flex-1 ${inputBg} border rounded-2xl px-4 py-3 focus:border-orange-500 ${textPrimary}`}
              />
              <input
                type="number"
                placeholder="%"
                value={newCoupon.discount}
                onChange={(e) => setNewCoupon({ ...newCoupon, discount: e.target.value })}
                className={`w-20 ${inputBg} border rounded-2xl px-4 py-3 focus:border-orange-500 ${textPrimary}`}
              />
              <button
                onClick={handleAddCoupon}
                className="bg-orange-600 hover:bg-orange-700 px-5 rounded-2xl text-white"
              >
                <Plus className="w-5 h-5" />
              </button>
            </div>

            <div className="space-y-3">
              {coupons.map((coupon) => (
                <div key={coupon.id} className={`${inputBg} border rounded-2xl px-5 py-4 flex items-center justify-between`}>
                  <div>
                    <p className={`font-medium ${textPrimary}`}>{coupon.code}</p>
                    <p className={`text-sm ${textSecondary}`}>{coupon.discount}% Discount</p>
                  </div>
                  <div className="flex items-center gap-3">
                    <button
                      onClick={() => toggleCoupon(coupon.id)}
                      className={`text-xs px-4 py-1 rounded-xl font-medium ${
                        coupon.active ? "bg-green-600 text-white" : "bg-gray-500 text-gray-200"
                      }`}
                    >
                      {coupon.active ? "Active" : "Inactive"}
                    </button>
                    <button
                      onClick={() => deleteCoupon(coupon.id)}
                      className="text-red-500 hover:text-red-600"
                    >
                      <Trash2 className="w-4 h-4" />
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}